const folder = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.5 2.69H16V5H0V1h6.21zM0 5.71h16V15H0z"/></svg>',
};

export { folder as default };
